import { useAccountsRefetch } from '@/entities/account';
import { useSessionStore } from '@/entities/session';
import { useCallback } from 'react';
import { useOperationsRefetch } from './useOperationsRefetch';

export const useAfterOperationRefresh = () => {
  const { session } = useSessionStore();
  const { refetchRestsOnly } = useAccountsRefetch({
    userId: session?.userId,
  });
  const { refetchAll: refetchOperations } = useOperationsRefetch({
    userId: session?.userId,
  });

  return useCallback(() => {
    refetchOperations();
    refetchRestsOnly();
  }, [refetchRestsOnly, refetchOperations]);
};
